import React from 'react';
import { useData } from '../contexts/DataContext';
import InventoryTab from '../components/wms/InventoryTab';

const WMSInventoryPage = () => {
  const { plants } = useData();
  
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Inventar Periodic - WMS</h1>
        <p className="text-slate-600 mt-1">Gestionare sesiuni de inventariere</p>
      </div>
      <InventoryTab plants={plants} />
    </div>
  );
};

export default WMSInventoryPage;